import {
  createContext,
  type ReactNode,
  type RefObject,
  useContext,
  useRef,
} from "react";

import type { MapboxOverlay } from "@deck.gl/mapbox";

type DeckGlMapContextType = {
  map: RefObject<MapboxOverlay | null>;
  init: (map: MapboxOverlay) => void;
};

const DeckGlMapContext = createContext<DeckGlMapContextType | null>(null);

export const useDeckGlMap = () => useContext(DeckGlMapContext);

export const DeckGlMapProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const map = useRef<MapboxOverlay | null>(null);

  const init = (mapInstance: MapboxOverlay) => {
    map.current = mapInstance;
  };

  return (
    <DeckGlMapContext.Provider value={{ init, map }}>
      {children}
    </DeckGlMapContext.Provider>
  );
};
